// extracted by mini-css-extract-plugin
export default {"productGrid":"R4-z","centerLink":"S4-z","productSection":"T4-z","item":"U4-z","ctaButton":"V4-z"};